// extracted by mini-css-extract-plugin
export default {"root":"VSoundScreen_root_qJNAN","slidecontainer":"VSoundScreen_slidecontainer_qkgm6","slider":"VSoundScreen_slider_2I2Ut","soundControl":"VSoundScreen_soundControl_2vOLi"};